import HeaderContainer from "./HeaderContainer";
import FooterContainer from "./FooterContainer";
import { Container, Form, InputGroup, Button } from "react-bootstrap";
import useConfig from "../hooks/useConfig";
import { ContainerButton } from "../components/FormElements";
import { React, useEffect, useState } from "react";
import { SpanError, SpanMessage } from "../components/Elements";
import { ReactComponent as SvgTrash } from '../images/trash-can.svg';
import { saveConfig } from "../firebase/firebaseOps";
import './ConfigContainer.css'; 

const ConfigContainer = () => {
    const initialConfig = useConfig();
    const [config, setConfig] = useState(initialConfig);
    const [message, setMessage] = useState('');
    const [error, setError] = useState(false);

    useEffect(() => {
        setConfig(initialConfig);
    }, [initialConfig]);

    const handleChange = (index, event) => {
        setMessage('');
        const { name, value } = event.target;
        if (name === 'places') {
            const newPlaces = [...config[0].places];
            newPlaces[index] = value;
            const newConfig = [...config];
            newConfig[0] = { ...config[0], places: newPlaces };
            setConfig(newConfig);
        } else if (name === 'categories') {
            const newCategories = [...config[0].categories];
            newCategories[index] = value;
            const newConfig = [...config];
            newConfig[0] = { ...config[0], categories: newCategories };
            setConfig(newConfig);
        }
    };

    const addPlace = () => {
        const newPlaces = [...config[0].places, ""];
        const newConfig = [...config];
        newConfig[0] = { ...config[0], places: newPlaces };
        setConfig(newConfig);
    };

    const addCategory = () => {
        const newCategories = [...config[0].categories, ""];
        const newConfig = [...config];
        newConfig[0] = { ...config[0], categories: newCategories };
        setConfig(newConfig);
    };

    const removePlace = (index) => {
        const newPlaces = [...config[0].places];
        newPlaces.splice(index, 1); // Eliminar el place en el índice dado
        const newConfig = [...config];
        newConfig[0] = { ...config[0], places: newPlaces };
        setConfig(newConfig);
    };

    const removeCategory = (index) => {
        const newCategories = [...config[0].categories];
        newCategories.splice(index, 1); // Eliminar la categoría en el índice dado
        const newConfig = [...config];
        newConfig[0] = { ...config[0], categories: newCategories };
        setConfig(newConfig);
    };

    const save = () => {
        saveConfig(config)
            .then(() => {
                setError(false);
                setMessage('Configuración guardada');
            })
            .catch((error) => {
                setError(true);
                setMessage('Error al guardar la información.');
            });
    };

    return (
        <>
            <HeaderContainer title="Configuración"></HeaderContainer>

            <Container className="container-normal">
                <h1>Lugares</h1>
                <div>
                    {config[0]?.places?.map((e, index) => (
                        <InputGroup key={index}>
                            <Form.Control className="input-group-margin" name="places" value={e} onChange={(event) => handleChange(index, event)} />
                            <SvgTrash className="svg-trash-margin" onClick={() => removePlace(index)} />
                        </InputGroup>
                    ))}
                    <Button variant="secondary" className="button-margin" onClick={addPlace}>Agregar</Button>
                </div>
                <h1>Categorias</h1>
                <div>
                    {config[0]?.categories?.map((e, index) => (
                        <InputGroup key={index} className="mb-3">
                            <Form.Control className="input-group-margin" name="categories" value={e} onChange={(event) => handleChange(index, event)} />
                            <SvgTrash className="svg-trash-margin" onClick={() => removeCategory(index)} />
                        </InputGroup>
                    ))}
                    <Button variant="secondary" className="button-margin" onClick={addCategory}>Agregar</Button>
                </div>
            </Container>
            <div>
                {error ? <SpanError><strong>{message}</strong></SpanError> : <SpanMessage><strong>{message}</strong></SpanMessage>}
            </div>
            <ContainerButton>
                <Button variant="primary" size="lg" onClick={save}>Guardar</Button>
            </ContainerButton>
            <FooterContainer />
        </>
    );
}

export default ConfigContainer;
